import React from 'react';
import { createOperationDescriptor, getRequest } from 'relay-runtime';
import { ReactRelayContext } from 'react-relay';
import { object, func } from 'prop-types';

export function PrepareRelayContextProvider(props) {
    const { environment, query, variables, render } = props;
    const operation = createOperationDescriptor(getRequest(query), variables);
    environment.retain(operation.root);

    const snapshot = environment.lookup(operation.fragment);
    const { data } = snapshot;

    return (
        <ReactRelayContext.Provider
            value={{
                environment: environment,
                variables,
            }}
        >
            {render({ props: data })}
        </ReactRelayContext.Provider>
    );
}

PrepareRelayContextProvider.propTypes = {
    environment: object,
    query: func,
    variables: object,
    render: func,
};
